<app-site-settings-menu>
    <div class="lookup-page" *ngIf="hasFeatureAccess">
        <div class="loading-container" *ngIf="isLoading">
            <ngx-skeleton-loader
                count="10"
                [theme]="{ 
                    'height.px': 50
                }"
            ></ngx-skeleton-loader>
        </div>

        <div class="lookup-shell" *ngIf="!isLoading">
            <aside class="lookup-sidebar">
                <div class="sidebar-heading">
                    <span class="eyebrow" setColor="primaryColour" appLocalizationPopupDirective localizationCode="LookupList-Configuration">{{'Configuration' | translate: {Default: 'Configuration'} }}</span>
                    <h2 appLocalizationPopupDirective localizationCode="LookupList-Title">{{'Lookup lists' | translate: {Default: 'Lookup lists'} }}</h2>
                    <p appLocalizationPopupDirective localizationCode="LookupList-Description">{{'Select a list field to manage its values.' | translate: {Default: 'Select a list field to manage its values.'} }}</p>
                </div>

                <mat-form-field class="search-field" appearance="outline">
                <input matInput
                           [(ngModel)]="tableListSearchValue"
                           placeholder="Search lists and fields"
                           aria-label="Search lists and fields">
                    <mat-icon matPrefix class="material-icons-outlined">search</mat-icon>
                </mat-form-field>

                <div class="tables-list-container">
                    <ng-container *ngIf="loadingTableList; else showList">
                        <ngx-skeleton-loader
                            count="10"
                            [theme]="{ 
                                'height.px': 50
                            }"
                        ></ngx-skeleton-loader>
                    </ng-container>
                    <ng-template #showList>
                        <mat-list>
                            <ng-container *ngFor="let tableList of tableLists | lookupListSearch:tableListSearchValue">
                                <div class="list-group-title" mat-subheader>{{tableList.name}}</div>
                                <mat-list-item
                                    *ngFor="let item of tableList.fields"
                                    appPreventDoubleClick
                                    (throttledClick)="selectedTableListField = item"
                                    [class.primaryColor]="selectedTableListField === item"
                                    setColor
                                    [setColorRules]="[
                                        {
                                            color: 'primaryColour',
                                            events: ['hover']
                                        },
                                        {
                                            color: 'primaryColour',
                                            setIfClass: ['primaryColor'],
                                        }
                                    ]"
                                >
                                    <mat-icon matListItemIcon class="material-icons-outlined">tune</mat-icon>
                                    <span matListItemTitle>{{item.name}}</span>
                                </mat-list-item>
                                <mat-divider></mat-divider>
                            </ng-container>
                        </mat-list>
                    </ng-template>
                </div>
            </aside>

            <div class="lookup-content">
                <app-lookup-list *ngIf="selectedTableListField" [tableList]="tableLists" [tableListField]="selectedTableListField"></app-lookup-list>
            </div>
        </div>
    </div>

    <no-feature-access *ngIf="!hasFeatureAccess"></no-feature-access>
</app-site-settings-menu>
